import React, { useMemo, useState } from 'react';
import { useField } from 'react-final-form';
import { ImportFromFile } from '@ubeya/shared-web/components';
import { createHandleDrop } from '@ubeya/shared-web/components/ImportFromFile/utils';

const UploadCostCentersFile = () => {
  const [isLoading, setLoading] = useState(false);
  const {
    input: { value, onChange }
  } = useField('file');

  const handleDrop = useMemo(() => createHandleDrop(onChange, setLoading), [onChange, setLoading]);

  return (
    <ImportFromFile
      handleDrop={handleDrop}
      value={value}
      isLoading={isLoading}
      showExcelExample
      importContext="costCenters"
    />
  );
};

export default UploadCostCentersFile;
